<template>
  <div class="main-layout">
    <top-announce-bar v-if="!showOnboarding" />

    <onboarding-desktop
      v-if="showOnboarding"
      @close="onCloseOnboarding"
    />

    <div class="body">
      <!--데스크탑 메뉴-->
      <div class="nav-side">
        <main-menu
          key="desktop"
          device="desktop"
          :is-collapsed="isSideMenuCollapsed"
        />
      </div>

      <van-popup
        v-if="isMobileWidth"
        v-model="showSideMenu"
        position="left"
        class="side-menu responsive-visible mobile"
        overlay-class="overlay-mobile"
        :overlay="true"
      >
        <div class="side-menu">
          <main-menu
            key="mobile"
            device="mobile"
            :is-closed="true"
            @close="showSideMenu = false"
          />
        </div>
      </van-popup>

      <div class="content-side">
        <div 
          class="content-side__nav" 
        >
          <top-announce-bar :is-desktop="false" />
          <div class="content-side__nav-menu">
            <div
              class="collapse-btn ic-collapse"
              @click="toggleMenuCollapse"
            />

            <div
              v-if="centerAccount"
              class="account-info"
            >
              <menu-alert />

              <menu-profile
                :profile-image-src="centerAccount.logo"
                :center-name="centerAccount.name"
                :is-demo-center="centerAccount.isDemoCenter"
              />
            </div>
          </div>
        </div>

        <div 
          class="main-content dashkit" 
          :style="{marginTop : contentMarginTop}"
        >
          <router-view />
          <section class="main-layout__footer">
            <fifl-footer />
          </section>
        </div>
      </div>
    </div>
    <custom-alert />
    <fetch-data-loading-message />
  </div>
</template>

<script>
import MainMenu from './MainMenu';
import { mapGetters } from 'vuex';
import { computedGetters } from '@/utils/vuex-helper';
import FiflFooter from '../../components/FiflFooter';
import TopAnnounceBar from './TopAnnounceBar';
import MenuProfile from './MenuProfile';
import MenuAlert from './MenuAlert';
import resizePageMixin from '../../mixins/resizePageMixin';
import OnboardingDesktop from './OnboardingDesktop';
import FetchDataLoadingMessage from '@/components/FetchDataLoadingMessage.vue';
import {
  bootFullStory,
  bootIntercom,
  shutdownIntercom
} from '@/utils/third-party-app';
import CustomAlert from '@/components/CustomAlert.vue';

const KOREA_TIMEZONE_OFFSET = -540;
const MOBILE_ANNOUNCE_HEIGHT = 40;
const MOBILE_HEADER_HEIGHT = 60;

export default {
  name: 'Layout',
  components: {
    OnboardingDesktop,
    MenuAlert,
    MenuProfile,
    TopAnnounceBar,
    FiflFooter,
    MainMenu,
    FetchDataLoadingMessage,
    CustomAlert
  },

  mixins: [resizePageMixin],
  data() {
    return {
      activeIndex: '/',
      isSideMenuCollapsed: false,
      showSideMenu: false,
      showOnboarding: false,
      isMobileWidth: window.innerWidth <= 768,
      windowWidth: window.innerWidth
    };
  },
  computed: {
    ...computedGetters(['noticeBarStatus']),
    ...mapGetters({
      centerAccount: 'getCenterAccount'
    }),
    isKoreaTimezone() {
      return new Date().getTimezoneOffset() === KOREA_TIMEZONE_OFFSET;
    },
    profileImageStyle() {
      return {
        backgroundImage: `url(${this.centerAccount.logo}`
      };
    },
    contentMarginTop() {
      if (this.isMobileWidth) {
        let TOTAL_MARGIN_TOP = MOBILE_HEADER_HEIGHT;
        if (!this.isKoreaTimezone) {
          TOTAL_MARGIN_TOP += MOBILE_ANNOUNCE_HEIGHT;
        }
        if (
          this.noticeBarStatus.isDisplayFreeCenterBar ||
          this.noticeBarStatus.isDisplayPrePaymentBar ||
          this.noticeBarStatus.isDisplayDemoCenterBar
        ) {
          TOTAL_MARGIN_TOP += MOBILE_ANNOUNCE_HEIGHT;
        }
        return TOTAL_MARGIN_TOP + 'px';
      }

      return 'initial';
    }
  },
  async created() {
    if (this.$route.query.onboarding === 'true') {
      this.$localStore.setValue('onboarding', 'notdone');
      this.showOnboarding = true;
    }

    if (this.$localStore.getValue('onboarding') === 'notdone') {
      this.showOnboarding = true;
    }

    await this.$store.dispatch('syncCenterAccount');
    await this.$store.dispatch('syncPolicy');
    bootIntercom(this.centerAccount);
    bootFullStory(this.centerAccount);
  },
  beforeDestroy() {
    shutdownIntercom();
  },
  async mounted() {
    if (this.token === null) {
      return this.$router.replace('/').catch(() => {});
    }
  },
  methods: {
    onResize() {
      this.isMobileWidth = window.innerWidth <= 768;
      this.isSideMenuCollapsed = window.innerWidth < 1200;
    },
    toggleMenuCollapse() {
      this.isSideMenuCollapsed = !this.isSideMenuCollapsed;
      this.showSideMenu = !this.showSideMenu;
    },
    onCloseOnboarding() {
      this.showOnboarding = false;
    }
  }
};
</script>

<style lang="scss">
.vertical-rule {
  font-style: normal;
  font-size: 17px;
  font-weight: 300;

  &::before {
    content: ' | ';
  }
}

.main-layout {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
  .main-layout__footer {
    flex: 1;
    display: flex;
    flex-direction: column-reverse;
  }
}

.announce-bar {
  order: 1;
  flex: initial;
  height: 45px;
  width: 100%;
  background-color: #4a4a4a;

  font-size: 15px;
  text-align: center;
  color: #ffffff;
  letter-spacing: -0.8px;
  line-height: 45px;
  position: relative;
  cursor: pointer;

  .ic-guidebar-close {
    position: absolute;
    top: 11px;
    right: 15px;
  }

  .button_buy-now {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -1.1px;
    text-align: center;
    color: #4a4a4a;

    padding: 0 9px;
    height: 31px;
    line-height: 31px;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    margin-left: 10px;

    text-decoration: none;
  }

  &.mobile {
    height: 40px;
    line-height: 40px;
    font-size: 13px;

    .button_buy-now {
      padding: 0 7px;
      font-size: 12px;
    }
  }
}

.body {
  flex: 1;
  order: 2;
  display: flex;
  background-color: #f6f6f6;
  overflow: auto;
}

.nav-side {
  height: 100%;
  order: 1;
  flex: initial;
  position: relative;
  overflow: hidden scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.content-side {
  flex: 1;
  min-width: calc(100% - 320px);
  order: 2;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  footer {
    flex: 1;
    display: flex;
    flex-direction: column-reverse;
  }
}

.top-bar-left {
  height: 60px;
  padding: 16px 22px;
  box-sizing: border-box;
}

.content-side__nav {
  flex: initial;
}

.side-menu {
  overflow: hidden scroll;
  width: 280px;
  height: 100%;
}

.content-side__nav-menu {
  height: 60px;
  background-color: white;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 50px;

  .collapse-btn {
    width: 32px;
    height: 100%;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
  }

  .account-info {
    box-sizing: border-box;
    height: 100%;
    display: flex;
  }

  @media screen and (max-width: 768px) {
    padding: 0 15px;
  }
}

@media screen and (max-width: 768px) {
  .body {
    background-color: #f6f6f6;
    min-width: inherit;
    min-height: 80vh;
  }

  .right-side {
    width: 100%;

    .page-area {
      overflow-y: auto;
      height: auto;
    }
  }

  .nav-side {
    height: auto;
  }

  .content-side {
    width: 100%;
    height: auto;
  }

  .content-side__nav {
    position: fixed;
    width: 100%;
    @media screen and (max-width: 768px) {
      z-index: 200 !important;
    }
  }
  .side-menu {
    z-index: 3001 !important;
  }
  .overlay-mobile {
    z-index: 3000 !important;
  }
}

.item-icon {
  width: 32px;
}

.icon {
  padding: 0 !important;
  width: 35px;
  height: 35px;
  background-color: black;
}
</style>
